/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class UserPreference {
    getFixupPrototypeFunction() { return UserPreference.fixupPrototype; }

    static newInstance(model: Partial<UserPreference>): UserPreference {
        let obj = Object.assign(new UserPreference(), model);
        UserPreference.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<UserPreference>): UserPreference {
        if (!model) return null;
        return UserPreference.newInstance(<UserPreference> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: UserPreference) {
        if (!obj) return;

        models.UserPreference.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: UserPreference): boolean {
        Object.setPrototypeOf(obj, UserPreference.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.created_at === "string") {
            this.created_at = new Date(<string><any>this.created_at);
        }
        if (typeof this.updated_at === "string") {
            this.updated_at = new Date(<string><any>this.updated_at);
        }
    }

    /**
     * Path is combination of id/key/value of user preference
     */
    path: string;

    /**
     * Name of the user preference
     */
    name: string;

    /**
     * Value of the user preference which is a JSON string
     */
    value: string;

    /**
     * When the user preference was created
     */
    created_at: Date;

    /**
     * When the user preference was updated
     */
    updated_at: Date;

}
